import { IRole } from '../interfaces/Itable';
import { baseApi } from './baseApi';

export const RolesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query<IRole[], void>({
      query: () => '/role/list',
      transformResponse: (response: { success: boolean; data: IRole[] }) => response.data,
      providesTags: ['Roles'],
    }),
    createRole: builder.mutation<IRole, Partial<IRole>>({
      query: (newRole) => ({
        url: "/role/create",
        method: "POST",
        body: newRole,
      }),
      invalidatesTags: ["Roles"],
    }),
    updateRole: builder.mutation<IRole, { id: number } & Partial<IRole>>({
      query: ({ id, ...updatedData }) => ({
        url: `/role/update/${id}`,
        method: "PUT",
        body: updatedData,
      }),
      invalidatesTags: ["Roles", "User"],
    }),
    deleteRole: builder.mutation<{ success: boolean; message: string }, number>({
      query: (id) => ({
        url: `/role/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Roles"],
    }),
  }),
});

export const { useGetRolesQuery, useCreateRoleMutation, useUpdateRoleMutation, useDeleteRoleMutation } = RolesApi;
